function MandatoryInformation() {
  return (
    <>
      <section className="mandatory-information">
        <h1>Mentions Légales</h1>
        <div>
          <h2>Informations du site</h2>
          <p>Propriétaire : Lemaire Plomberie des weppes</p>
          <p>Siège social : 25 rue du rosoir 59211 santes </p>
          <p>Téléphone : 06.68.86.07.78</p>
          <p>Email : LPweppes@outlook.fr</p>
          <p>Numéro de TVA : FR48930373766</p>
          <p>Responsable de la publication : Lemaire Plomberie des weppes</p>
          <p>Hébergeur : Netlify - Pl. Édouard VII, 75009 Paris</p>
        </div>
        <div className="intellectual-property">
          <h2>Propriété intellectuelle</h2>
          <p>
            Tous les textes et images sur le site Lemaire Plomberie des weppes sont strictement réservés au titre du droit d'auteur ainsi
            qu'au titre de la propriété intellectuelle et pour le monde entier. À ce titre et conformément aux dispositions du code de la
            propriété intellectuelle, seule l'utilisation pour un usage privé sous réserve de dispositions différentes voire plus
            restrictives du code de la propriété intellectuelle est autorisée. Dans ces conditions, l'internaute s’engage à ne pas
            reproduire, résumer, modifier, altérer ou rediffuser les éléments sans autorisation écrite de Lemaire Plomberie des weppes.
          </p>
        </div>
        <div className="intellectual-property">
          <h2>Données personnelles</h2>
          <p>
            Les données personnelles vous concernant, recueillies par l’intermédiaire du formulaire en ligne sont utilisées par la société
            Lemaire Plomberie des weppes uniquement dans le cadre de la prise de contact suite à votre demande qui peut concerner une
            intervention, une demande de tarifs, un dépannage, une demande de devis. Le destinataire de ces données est le responsable du
            traitement des données. Leur durée de conservation est de 3 ans. Conformément à la loi informatique et libertés du 6 janvier
            1978 et le RGPD, vous bénéficiez d'un droit d'accès, de rectification, de portabilité, d'effacement de celles-ci ou de demander
            la limitation du traitement. Vous pouvez vous opposer au traitement des données vous concernant et disposez du droit de retirer
            votre consentement à tout moment en vous adressant à ajouter email
          </p>
        </div>
      </section>
    </>
  );
}

export default MandatoryInformation;
